export const PRO = process.env.NEXT_PUBLIC_VERCEL_ENV === 'production'
export const LANGUAGES = ['es', 'cat', 'en', 'fr', 'it'] as const
export type TypeLang = (typeof LANGUAGES)[number]

export const LANG = process.env.NEXT_PUBLIC_LOCALE as TypeLang
export const HOSTNAME = process.env.NEXT_PUBLIC_HOSTNAME
export const CLIENT_NAME = 'Corso'


export * from './slugify'
export * from './parserMedia'
export * from './restaurantDates'
